import { visuallyHiddenStyles } from "@newsela/angelou";
import PropTypes from "prop-types";

import sentenceCase from "@/utils/sentenceCase";
import { colorPickerColors } from "@/view/ColorPicker/ColorPicker.constants";
import { labelCss } from "./StaticColorIndicator.style";

const propTypes = {
  penName: PropTypes.string,
};

const StaticColorIndicator = ({ penName }) => {
  const getColor = () => {
    return colorPickerColors.filter((colorPickerColor) => {
      return colorPickerColor.penName === penName;
    });
  };

  const color = getColor()[0];

  return (
    <div css={labelCss(color?.label)}>
      {sentenceCase(color?.label)}
      <span css={visuallyHiddenStyles}> annotation highlight</span>
    </div>
  );
};

StaticColorIndicator.propTypes = propTypes;

export default StaticColorIndicator;
